/* Code generated with AutoHTML Plugin for Figma */
import { ID, Place, ProductFront } from "@project/shared-types";
import { useMemo, useState } from "react";
import ArrowDownSvg from "../../../assets/taiga-uikit/icons/arrow-right-1.svg?react";
import { Button } from "../../../components/button/button";
import Title from "../../../components/texts/title";
import { _sizeHeading, _style } from "../../../core/core";
import { useData } from "../../../entities/service/model/DataContext";
import { ServiceView } from "../../../entities/service/ui/ServiceCard";
import "./UslugiBlock.css";

export const UslugiBlock: React.FC<{
  title: string;
  product_ids?: ID[];
  children?: React.ReactNode;
}> = ({ title, product_ids, children }) => {
  const { products } = useData();
  const products_ready = useMemo(() => {
    if (product_ids && product_ids.length > 0) {
      return products.filter((x) => product_ids.includes(x.id));
    }
    return products;
  }, [product_ids, products]);
  const places = useMemo(() => {
    return products.map((x) => {
      return x.place;
    });
  }, [products]);
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  return (
    <div className={"uslugi-block "}>
      {isMobile ? (
        <UslugiMod
          products={products_ready}
          places={places}
          children={children}
        />
      ) : (
        <UslugiDesktop
          title={title}
          products={products_ready}
          places={places}
          children={children}
        />
      )}
    </div>
  );
};
const UslugiMod = ({
  products,
  places,
  children,
}: {
  products: ProductFront[];
  places: Place[];
  children?: React.ReactNode;
}) => {
  const [hidePlacesIds, setHidePlacesIds] = useState<ID[]>([]);

  const onClick = (place: Place) => {
    if (hidePlacesIds.findIndex((p) => p === place.id) === -1)
      setHidePlacesIds((prev) => [...prev, place.id]);
    else setHidePlacesIds((prev) => prev.filter((p) => p !== place.id));
  };
  return (
    <>
      <div className="uslugi-block-items">
        {places.map((place, index) => (
          <div
            key={index}
            className={`uslugi-item-${hidePlacesIds.findIndex((p) => p === place.id) === -1
              }`}
          >
            <div onClick={() => onClick(place)} className="uslugi-item-h">
              <Title type={_sizeHeading.h2_2}>{place.title}</Title>
              <div className="uslugi-item-h-icon">
                <ArrowDownSvg />
              </div>
            </div>
            <div className="uslugi-item-l">
              {products
                .filter((s) => s.place_id === place.id)
                .map((service, index) => (
                  <ServiceView key={index} service={service}></ServiceView>
                ))}
            </div>
          </div>
        ))}
        {children}
      </div>
    </>
  );
};

interface UslugiDesktopProps {
  products: ProductFront[];
  title: string;
  places: Place[];
  children?: React.ReactNode;
}

const UslugiDesktop: React.FC<UslugiDesktopProps> = ({
  products,
  title,
  places,
  children,
}) => {
  const [selectPlace, setSelectPlace] = useState<Place | null>(null);

  return (
    <>
      <div className="uslugi-block-l">
        <Title type={_sizeHeading.h2_2}>Площадки</Title>
        <div className="uslugi-block-l-items">
          {places.map((place: Place, index: number) => (
            <Button
              width={"100%"}
              style={_style.outline}
              key={index}
              icon_right={<ArrowDownSvg />}
              onClick={() => setSelectPlace(place)}
            >
              {place.title}
            </Button>
          ))}
        </div>
      </div>
      <div className="uslugi-block-items">
        <div className="uslugi-item-true">
          <div className="uslugi-item-h">
            <Title type={_sizeHeading.h2_2}>{title}</Title>
          </div>
          <div className="uslugi-item-l">
            {selectPlace ? (
              <>
                {products
                  .filter((s: ProductFront) => s.place_id === selectPlace.id)
                  .map((service: ProductFront, index: number) => (
                    <ServiceView key={index} service={service}></ServiceView>
                  ))}
              </>
            ) : (
              <>
                {products.map((service: ProductFront, index: number) => (
                  <ServiceView key={index} service={service}></ServiceView>
                ))}
              </>
            )}
          </div>
          {children}
        </div>
      </div>
    </>
  );
};
